import React from "react";
import RefundPolicy from "../components/RefundPolicy";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const RefundPolicyPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Refund Policy" />
      <RefundPolicy />
    </>
  );
};

export default RefundPolicyPage;